import { ShaderStore } from "@babylonjs/core";
const name = "clipFragment";
const shader = `#if defined(HOLOGRAPHIC_BOUNDS_BOX) || defined(HOLOGRAPHIC_BOUNDS_CYLINDER) || defined(HOLOGRAPHIC_BOUNDS_SPHERE)
bvec4 isNegative=lessThan(vfClipDistance,vec4(0.0));bool anyNegative=any(isNegative);if (anyNegative) {discard;}#endif
`;
ShaderStore.IncludesShadersStore[name] = shader;
export const clipFragment = { name, shader };
//# sourceMappingURL=clipFragment.js.map